const breakpoints = {
    desktop: 980,
    leftCol: 1140,
    mobile: 320,
    mobileLandscape: 480,
    mobileMedium: 375,
    phablet: 660,
    tablet: 740,
    wide: 1300
};
export { breakpoints };
